import React from 'react';
import doctorProfileImage from '../../assets/doctorprofile.png';

const DrAeshaProfile = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-20 py-16 bg-gradient-to-b from-white to-green-50">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
        {/* Left Content */}
        <div className="space-y-6 m-auto">
          <h1 className="text-4xl font-serif text-teal-600">
            Dr. Aesha Thakkar
          </h1>
          <h2 className="text-xl font-serif text-teal-600">
            Founder of Pristine Smile
          </h2>
          
          <div className="border-l-4 border-lime-500 pl-4 mb-6">
            <p className="text-gray-600 italic">
              Bringing pristine smiles to life with compassionate care
            </p>
          </div>
          
          <div className="space-y-6 text-gray-700 leading-relaxed">
            <p>
              Dr. Aesha Thakkar is a compassionate and skilled general dentist dedicated to helping patients of all ages achieve healthy, beautiful smiles. With a focus on patient comfort and personalized care, Dr. Thakkar blends clinical excellence with a gentle, friendly approach that puts patients at ease the moment they walk in.
            </p>
            <p>
              A graduate of College of Dental science and Hospital(Rau,Indore), Dr. Thakkar has built a reputation for thorough, thoughtful dentistry — whether it’s routine checkups, cosmetic treatments, or restorative procedures. She is passionate about educating patients, empowering them to make informed decisions about their oral health.
            </p>
            <p>
              Having visited and trained in leading dental practices across metro city like Mumbai , Dr. Thakkar brings a wide range of clinical exposure and advanced techniques to her practice. These experiences have helped her stay updated with the latest trends in dentistry — from cutting-edge technology to modern treatment protocols — all of which she integrates into her work at Pristine Smile.
            </p>
            <p>
              At Pristine Smile, Dr. Thakkar’s mission is to create a welcoming space where dental care feels less like a chore and more like a step toward greater confidence and well-being. Her commitment to continuing education and the latest dental technology ensures that every patient receives the highest quality of care.
            </p>
          </div>
          
          <div className="flex space-x-4 mt-8">
            <button className="px-6 py-3 bg-teal-500 hover:bg-teal-600 text-white rounded-lg shadow transition-colors">
              Book Appointment
            </button>
            <button className="px-6 py-3 bg-white border-2 border-lime-500 text-lime-600 hover:bg-lime-50 rounded-lg shadow transition-colors">
              View Services
            </button>
          </div>
        </div>

        {/* Right Image */}
        <div className="lg:pl-8">
          <div className="relative">
            <div className="absolute -top-4 -left-4 w-24 h-24 bg-lime-400 rounded-full opacity-20"></div>
            <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-teal-400 rounded-full opacity-20"></div>
            <img
              src={doctorProfileImage}
              alt="Dr. Aesha Thakkar"
              className="w-full rounded-lg shadow-lg object-cover relative z-10 border-4 border-white"
              style={{maxHeight: '700px'}}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DrAeshaProfile;